import { State } from '../../../store/state';

export const companiesSelector = (state: State) => state.company.companies;
export const companySelector = (state: State) => state.company.company;
export const selectedSelector = (state: State) => state.company.selected;
export const usersSelector = (state: State) => state.company.users;
export const storesSelector = (state: State) => state.company.stores;
export const storeSelector = (state: State) => state.company.store;
export const importationsSelector = (state: State) => state.company.importations;
export const optionsSelector = (state: State) => state.company.options;
export const errorCodeSelector = (state: State) => state.company.errorCode;